<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader :shopcart="shopcart" :shopcart_qty="shopcart_qty" :shopcart_total="shopcart_total"
			@data-updated-shopcart="handleShopcartUpdated"></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
				<div
					style="float: right;width:calc(100% - 269px);overflow: auto;height:1090px;background: white;border-radius: 5px;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						 <span style="color:#07ccec;">发票抬头</span>
					</h6>
					<el-row>
						<a href="#/user/invoice/new">
							<el-button style="margin-top: 20px;background: red;color:white;">新增发票抬头</el-button>
						</a>
					</el-row>
					<el-table :data="invoice_datas" style="width: 95%;margin:30px auto;" stripe>
						<el-table-column fixed prop="unit_name" label="发票抬头" width="150">
						</el-table-column>
						<el-table-column prop="tax_number" label="统一社会信用用代码" width="150">
						</el-table-column>
						<el-table-column prop="bank" label="开户银行名称" width="180">
						</el-table-column>
						<el-table-column prop="address" label="注册场所地址" width="180">
						</el-table-column>
					
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="150">
							<template slot-scope="scope">
								<a style="margin-right:10px;">
									<el-button @click="turn_to_change_invoice(scope.row)" type="success" size="small">修改
									</el-button>
								</a>
								<el-button type="danger" size="small" @click="delete_info(scope.row)">删除</el-button>
								<!-- <el-button type="text" size="small">设为默认</el-button> -->
							</template>
						</el-table-column>
					</el-table>
				<!-- 	<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="pageSizes" :page-size="PageSize" background
						layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
					</el-pagination> -->
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'Demo',
		data() {
			return {
				selected_page:'3-2',
				tableData: [{
					company: '测试单位1',
					tax_number: '0092847690',
					address: '测试地址1',
					postal_code: '000000',
					client: '姓名1',
					category: '科别1',
					telephone: '12345678900',
					phone: '028-12345678',
					postbox: '534267189@qq.com',
				}, {
					company: '测试单位2',
					tax_number: '0092847690',
					address: '测试地址2',
					postal_code: '000000',
					client: '姓名2',
					category: '科别2',
					telephone: '12345678900',
					phone: '028-12345678',
					postbox: '534267189@qq.com',
				}],
				invoice_datas: [],
				currentPage: 1,
				// 总条数，根据接口获取数据长度(注意：这里不能为空)
				totalCount: 40,
				// 个数选择器（可修改）
				pageSizes: [10, 20, 40, 80],
				// 默认每页显示的条数（可修改）
				PageSize: 20,
				shopcart_qty: 0,
				shopcart_total: 0,
				shopcart:'',
			}
		},
		mounted() {
			this.get_invoice_data()
			this.get_shopcart()
			// var self = this
			// fetchGet('/ro/report_data_center/fcst/datas/sale').then(function(data) {
			// 	// debugger;
			// 	self.customer_options = data.data['partner_data']
			// 	self.product_options = data.data['product_data']
			// 	// self.tableData = data.data['partner_data']
			// 	console.log(self.tableData)

			// })


			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {
			get_shopcart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == ''||shopcart==null) {
					shopcart = [];
				}
				else{
					shopcart = JSON.parse(shopcart)
				}
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total+=parseFloat(shopcart[i].total)
				}
				
				this.shopcart = shopcart
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
			},
			
			handleShopcartUpdated(updatedData) {
				this.shopcart = parseFloat( updatedData).toFixed(2);
			},
			handleShopcartQtyUpdated(updatedData) {
				this.shopcart_qty =  parseFloat( updatedData).toFixed(2);;
			},
			handleShopcartTotalUpdated(updatedData) {
				this.shopcart_total =  parseFloat( updatedData).toFixed(2);;
			},
			
			handleClose(done) {
				var self = this
				this.$confirm('确认删除？')
					.then(_ => {
						console.log('slslslsl')
						var data = {
							'id': self.now_select_address_info.id
						}
						fetchPost('/ro/tec_search/invoice/delete/v1', data).then(response => {
							self.get_invoice_data()
						})
					})
					.catch(_ => {});
			},
			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_invoice_data()
			},

			handleSizeChange(val) {
				console.log(val)
				console.log('handleSizeChange')
				this.PageSize = val
				this.get_invoice_data()
			},

			turn_to_change_invoice(row) {
				// #/user/change_infor
				console.log(row);
				window.localStorage.setItem('now_select_invoice_info', JSON.stringify(row))
				this.$router.push('/user/invoice/change')
			},
			delete_info(row) {
			
				var self = this
				this.now_select_address_info = row
				self.handleClose()
				

			},
			get_invoice_data() {
				var data = {
					'id': window.localStorage.getItem('eshop_user_id'),
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				// debugger
				var self = this
				fetchPost('/ro/eshop/invoice/list/v1', data).then(response => {
					// console.log(response)

					self.invoice_datas = response.data.list
					self.totalCount = response.total

				})
			},

		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}
</style>
